<template>
  <div>
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div
      id="content"
      class="login h-100"
      style="
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        height: 100vh;
      "
    >
      <!-- <br> -->
      <div class="card card-style" style="width: 100%">
        <div class="content">
          <div style="text-align: center !important">
            <img
              src="../assets/images/it4d-e-samu.png"
              alt="logo"
              height="55"
              style="
                margin-top: 0.5rem !important;
                margin-bottom: 30px !important;
              "
            />
          </div>

          <!-- <h1 class="text-center font-800 font-30 mb-2">Sign In</h1> -->

          <p class="text-left font-13 mt-n2 mb-3">
            Preencha os dados abaixo para se cadastrar
          </p>

          <div class="form-custom form-label mb-3">
            <input
              type="email"
              class="form-control rounded-xs"
              id="c1"
              placeholder="E-mail"
              v-model="users.login"
            />
            <label for="c1" class="color-theme">Login</label>
            <span>(obrigatório)</span>
          </div>
          <div class="form-custom form-label mb-3">
            <input
              type="tel"
              class="form-control rounded-xs"
              id="c1"
              placeholder="Telefone 1"
              v-mask="'(99) 99999-9999'"
              v-model="users.telefone"
              autocomplete="new-password"
            />
            <label for="c1" class="color-theme">Telefone 1</label>
            <span>(obrigatório)</span>
          </div>

          <div class="form-custom form-label mb-3">
            <input
              type="tel"
              class="form-control rounded-xs"
              id="c1"
              placeholder="CPF"
              v-model="users.cpf"
              v-mask="'999.999.999-99'"
            />
            <label for="c1" class="color-theme">CPF</label>
            <span>(obrigatório)</span>
          </div>

          <div class="form-custom form-label mb-3">
            <input
              type="text"
              class="form-control rounded-xs"
              id="c1"
              placeholder="Nome Completo"
              v-model="users.usuario_nome"
              autocomplete="new-password"
            />
            <label for="c1" class="color-theme">Nome Completo</label>
            <span>(obrigatório)</span>
          </div>

          <div class="form-custom form-label mb-3">
            <input
              type="password"
              class="form-control rounded-xs"
              id="c2"
              placeholder="Senha"
              v-model="users.senha"
              autocomplete="new-password"
            />
            <label for="c2" class="color-theme">Senha</label>
            <span>(obrigatório)</span>
          </div>

          <div class="form-custom form-label mb-3">
            <input
              type="password"
              class="form-control rounded-xs"
              id="c2"
              placeholder="Confirmação de Senha"
              v-model="users.senha_confirmacao"
            />
            <label for="c2" class="color-theme">Confirmação de Senha</label>
            <span>(obrigatório)</span>
          </div>

          <a
            href="#"
            style="background-color: #15488a !important"
            class="btn rounded-sm btn-m text-uppercase font-700 mt-4 mb-3 btn-full shadow-bg shadow-bg-s"
            @click="cadastrar"
            >CADASTRAR</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      new_path: "/dashboard",
      loadingColor: "#5D9CEC",
      email: "",
      password: "",
      forgot: {
        email: "",
      },
      users: {
        cpf: "",
        usuario_nome: "",
        telefone: '',
        login: "",
        perfil_id: 2,
        senha: "",
        senha_confirmacao: "",
      },
      isLoading: false,
    };
  },
  computed: {},
  methods: {
    reveal() {
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    makeFormData() {
      const self = this;
      let fd = new FormData();

      /* let photo = document.getElementById("userPic"); */

      fd.append("usuario_nome", self.users.usuario_nome);
      fd.append("login", self.users.login);
      fd.append("cpf", self.users.cpf);
      fd.append("perfil_id", self.users.perfil_id);
      fd.append("senha", self.users.senha);
      fd.append("telefone", self.users.telefone);
      fd.append("senha_confirmacao", self.users.senha_confirmacao);

      fd.append("_method", "POST");

      /* fd.append("foto", photo.files[0] ? photo.files[0] : "");

      if (self.users.id) {
        fd.append("id", self.users.id);
        fd.append("_method", "PUT");
      } */

      return fd;
    },
    cadastrar() {
      const self = this;
      let api = self.$store.state.api + "users/add-solicitante";

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Cadastro realizado com sucesso!`,
            "success"
          );
          self.login();
          self.isLoading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    aplicarMascaraCpf(cpf) {
      cpf = this.users.cpf.replace(/\D/g, "");

      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },

    login() {
      let self = this;
      self.isLoading = true;
      const cpfComMascara = self.aplicarMascaraCpf(self.users.cpf);
      const api = this.$store.state.api + "login";

      axios
        .post(api, {
          cpf: cpfComMascara,
          senha: this.users.senha,
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);
          self.$store.commit("usuario_id", response.data.usuario_id);
          self.$store.commit("usuario_nome", response.data.usuario_nome);
          self.isLoading = false;
          self.$router.push({ path: this.new_path });
        })
        .catch((error) => {
          self.isLoading = false;
          self.$message("Erro", "Credenciais incorretas", "error");
        });
    },

    /* forgotPassword() {
      const self = this;
      const api = this.$store.state.api + "user/recovery";

      axios
        .post(api, {
          email: self.forgot.email,
        })
        .then((response) => {
          self.$message(
            "Sucesso",
            "Solicitação realizada com sucesso",
            "success"
          );
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    }, */
  },
  components: { Loading },
  props: {},
  mounted: function () {
    const self = this;

    var url = self.$route.fullPath.split("?url=%2F");
    if (url[1]) {
      self.new_path = url[1];
    }
  },
};
</script>
<style scoped>
input {
  color: black;
}

label {
  margin-bottom: -3px;
  margin-top: 3px;
}

.login a {
  color: #ffffff;
}

/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}
</style>


// WEBPACK FOOTER //
// src/components/CriarConta.vue